"use strict";

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

Object.defineProperty(exports, "__esModule", {
  value: true
});

var BaseTransform_1 = require("./BaseTransform");

var ConditionalHelper_1 = require("../../helpers/ConditionalHelper");

var Query_1 = require("../Query");

var SwitchTransform =
/** @class */
function (_super) {
  __extends(SwitchTransform, _super);

  function SwitchTransform() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  SwitchTransform.prototype.execute = function (queryResponse, queryOptions, executionOptions) {
    var switchOptions = this.options.switchOptions;

    if (switchOptions) {
      var defaultResponse = switchOptions.defaultResponse,
          cases = switchOptions.cases,
          _a = switchOptions.useValueAsResponse,
          useValueAsResponse = _a === void 0 ? false : _a;
      var response = defaultResponse;

      if (useValueAsResponse) {
        response = queryResponse;
      }

      for (var _i = 0, cases_1 = cases; _i < cases_1.length; _i++) {
        var caseInstance = cases_1[_i];
        var conditional = caseInstance.conditional,
            caseResponseStatic = caseInstance.response,
            caseResponseQuery = caseInstance.responseQuery,
            value = caseInstance.value;
        var caseResponse = caseResponseStatic;

        if (caseResponseQuery) {
          var query = new Query_1.Query(caseResponseQuery);
          caseResponse = query.execute(executionOptions);
        }

        if (value) {
          if (queryResponse === value) {
            response = caseResponse;
            break;
          }
        } else if (conditional) {
          var conditionalHelper = new ConditionalHelper_1.ConditionalHelper(conditional, this.translationHelper);

          if (conditionalHelper.matchesWithOptions({
            executionOptions: executionOptions,
            instance: queryResponse
          })) {
            response = caseResponse;
            break;
          }
        }
      }

      return response;
    }

    return;
  };

  return SwitchTransform;
}(BaseTransform_1.BaseTransform);

exports.SwitchTransform = SwitchTransform;